/**
 * The release currently announced by <ReleaseBanner />. Edit and redeploy to
 * announce something new; set to null to hide it. No backend involved.
 *
 * The banner disappears on its own once `until` has passed.
 *
 * Bump `id` for every new announcement: dismissals are remembered per id, so a
 * new id shows the banner again to everyone who closed the previous one.
 */
export type ReleaseAnnouncement = {
  /** Master switch: false hides the banner without touching the rest. */
  enabled: boolean
  id: string
  /** Last moment to show the banner, ISO date in Baku time, e.g. '2026-10-19T23:59:59+04:00'. */
  until: string
  title: string
  description?: string
  /** Internal path ("/timer") or external URL. */
  link?: string
  linkLabel?: string
}

export const RELEASE_ANNOUNCEMENT: ReleaseAnnouncement | null = {
  enabled: true,
  id: '2026-10-appeals',
  until: '2026-11-04T23:59:59+04:00',
  title: 'Yeni alət: Apelyasiya meneceri',
  description: 'Apelyasiya otağı yaradın: komandalar apelyasiya yazır, jürilər rəy verir, siz hamısını bir yerdə izləyirsiniz.',
  link: '/tournament-panel/appeals',
  linkLabel: 'Aç',
}
